import React, { Component } from "react";
import NotificationSystem from "react-notification-system";
import { AvForm, AvField } from "availity-reactstrap-validation";

import arrow from "../../assets/images/arrowCardRight.svg";
import arrowHeader from "../../assets/images/arrowHeader.svg";

import "./contact.scss";

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: "",
      email: "",
      message: ""
    };
  }

  sendEmail = () => {
    let that = this;
    const message = `<span>Name: ${this.state.fullName}</span>
    <br>
    <span>Email: ${this.state.email}</span>
    <br>
    <span>Message: ${this.state.message}</span>`;

    window.emailjs
      .send("smtp_server_wizy", "template_6eFg6Vwx", {
        from_name: this.state.fullName,
        message_html: message
      })
      .then(
        function(response) {
          that.refs.notificationSystem.addNotification({
            message: "We have received your contact request!",
            level: "success"
          });
        },
        function(err) {
          that.refs.notificationSystem.addNotification({
            message: "Sending email failed!",
            level: "error"
          });
        }
      );

    that.refs.notificationSystem.addNotification({
      message:
        "Thanks for contacting us! We will get in touch with you soon.",
      level: "success"
    });
  };

  render() {
    return (
      <div className="contact-container">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <AvForm onValidSubmit={this.sendEmail}>
                <h1 className="contact-title">Let's talk</h1>
                <p className="description-contact">
                  We are very excited if we have an opportunity to collaborate
                  with you. Please leave us some information from you, we will
                  contact you shortly.{" "}
                </p>
                <AvField
                  id="fullNameCustomer"
                  name="fullNameCustomer"
                  className="input-contact"
                  placeholder="Your Full Name"
                  type="text"
                  onChange={e => {
                    this.setState({ fullName: e.target.value });
                  }}
                  value={this.state.fullName}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please enter your Full Name"
                    }
                  }}
                />
                <br />
                <AvField
                  id="emailCustomer"
                  name="emailCustomer"
                  className="input-contact"
                  placeholder="Your Email"
                  type="email"
                  value={this.state.email}
                  onChange={e => {
                    this.setState({ email: e.target.value });
                  }}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please enter your Email"
                    }
                  }}
                />
                <br />
                <AvField
                  id="contentCustomer"
                  name="contentCustomer"
                  className="input-contact"
                  placeholder="What We Can Help You?"
                  type="textarea"
                  value={this.state.message}
                  onChange={e => {
                    this.setState({ message: e.target.value });
                  }}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please enter your Message"
                    }
                  }}
                />
                <br />
                <NotificationSystem ref="notificationSystem" />
                <button type="submit" className="btn btn-primary btn-contact">
                  <span>Send Us</span>
                  <img src={arrow} alt="" />
                </button>
              </AvForm>
            </div>
            <div className="col-md-6 d-flex flex-column justify-content-end">
            <h1 className="contact-title text-center">Or schedule a call...</h1>
              <a class="button-schedule-call circle" href="/call">
                schedule a call
              </a>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p>
                Or you can send a message to us via Skype. We are available in
                office hours (GMT: +7):
              </p>
              <button
                type="button"
                className="btn btn-link btn-skype"
                onClick={() => {
                  window.location.href = "skype:live:info_680348?chat";
                }}
              >
                <span>Skype: info@wizy.vn</span>
                <img src={arrowHeader} alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Contact/Contact.js